import { spaceClient } from './client';

// The games THIS space has (GET /api/space/{spaceId}/games). The master catalog (/api/games) is global, but
// the games a space can use are assigned to it (space_game), so every game select in the CMS — Game Score
// Board, Game Announcements, Game Schedule — reads this list. Each entry is the master game's fields plus the
// space's own `pointsPerCorrect` (null for games that don't score by points) and `createdTime`.
export const getGames = () =>
  spaceClient.get('/games').then((r) => r.data);

// Scoreboard rows for one game, scoped to the active space via spaceClient.
// filter: 'weekly' | 'monthly' | 'custom' (default 'monthly' on the backend if omitted).
// from/to ('YYYY-MM-DD') are required only when filter === 'custom'.
// search / sortDirection are optional — only sent when actually set, so we don't push
// empty query params onto every request.
export const getScoreboard = (gameId, {
  filter = 'monthly', from, to, page = 1, pageSize = 25, search, sortDirection,
} = {}) =>
  spaceClient
    .get(`/games/${gameId}/leaderboard/scoreboard`, {
      params: {
        filter,
        from,
        to,
        page,
        pageSize,
        ...(search ? { search } : {}),
        ...(sortDirection ? { sortDirection } : {}),
      },
    })
    .then((r) => r.data);

// Per-player match history for the drill-down modal. filter/from/to mirror whatever the
// scoreboard table currently has applied, so the history agrees with what's on screen.
export const getPlayerHistory = (gameId, userId, { filter = 'monthly', from, to, limit = 5 } = {}) =>
  spaceClient
    .get(`/games/${gameId}/leaderboard/scoreboard/${userId}/history`, {
      params: { filter, from, to, limit },
    })
    .then((r) => r.data);
